"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSelectOption = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

var _sbCheckbox = require("../sb-checkbox");

var _constants = require("./constants");

var _shapes = require("./shapes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP = _constants.DIVIDER_POSITIONS.TOP,
    BOTTOM = _constants.DIVIDER_POSITIONS.BOTTOM;
var RADIO = _constants.MODE.RADIO,
    CHECKBOX = _constants.MODE.CHECKBOX;

var SbSelectOption = /*#__PURE__*/function (_Component) {
  _inherits(SbSelectOption, _Component);

  var _super = _createSuper(SbSelectOption);

  function SbSelectOption() {
    var _this;

    _classCallCheck(this, SbSelectOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnOptionClick", function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onOptionClick = _this$props.onOptionClick,
          value = _this$props.value;
      event.preventDefault(); // otherwise does not work, when embedded in other element (such as label)

      onClick({
        onClick: onOptionClick,
        value: value,
        event: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseEnter", function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onMouseEnter = _this$props2.onMouseEnter;
      onMouseEnter(value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseLeave", function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          onMouseLeave = _this$props3.onMouseLeave;
      onMouseLeave(value);
    });

    _defineProperty(_assertThisInitialized(_this), "setReferences", function (node) {
      var _this$props4 = _this.props,
          optionRef = _this$props4.optionRef,
          isSelected = _this$props4.isSelected,
          setSelected = _this$props4.setSelected;

      if (isSelected && setSelected) {
        setSelected(node);
      }

      if (optionRef) {
        optionRef(node);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props5 = _this.props,
          mode = _this$props5.mode,
          isSelected = _this$props5.isSelected,
          children = _this$props5.children,
          name = _this$props5.name,
          label = _this$props5.label,
          disabled = _this$props5.disabled,
          value = _this$props5.value,
          iconClass = _this$props5.iconClass;
      var innerChildren = children || label || name || value;
      var icon = iconClass ? /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)('option-icon', iconClass)
      }) : null;
      return mode === CHECKBOX ? /*#__PURE__*/_react.default.createElement(_sbCheckbox.SbCheckbox, {
        checked: isSelected,
        className: "select-option-checkbox",
        disabled: disabled
      }, icon, innerChildren) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon, innerChildren);
    });

    return _this;
  }

  _createClass(SbSelectOption, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          className = _this$props6.className,
          disabled = _this$props6.disabled,
          divider = _this$props6.divider,
          iconClass = _this$props6.iconClass,
          isSelected = _this$props6.isSelected,
          isPreselected = _this$props6.isPreselected,
          setSelected = _this$props6.setSelected,
          style = _this$props6.style,
          id = _this$props6.id,
          optionRef = _this$props6.optionRef,
          onOptionClick = _this$props6.onOptionClick,
          indeterminate = _this$props6.indeterminate,
          label = _this$props6.label,
          mode = _this$props6.mode,
          rest = _objectWithoutProperties(_this$props6, ["className", "disabled", "divider", "iconClass", "isSelected", "isPreselected", "setSelected", "style", "id", "optionRef", "onOptionClick", "indeterminate", "label", "mode"]);

      var buttonClassName = (0, _classnames.default)('sb-select-option', className, disabled ? 'sb-select-option-disabled' : null);
      var dividerOptions = !(0, _isEmpty.default)(divider) ? divider : {};
      var dividerClass = dividerOptions.dividerClass,
          dividerStyle = dividerOptions.dividerStyle,
          dividerPosition = dividerOptions.dividerPosition;

      if (mode === _constants.MODE.RADIO && (isPreselected || isSelected)) {
        buttonClassName = (0, _classnames.default)(buttonClassName, 'hover');
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, divider && dividerPosition === TOP && /*#__PURE__*/_react.default.createElement(_index.SbSelectDivider, {
        className: dividerClass,
        style: dividerStyle
      }), /*#__PURE__*/_react.default.createElement("button", _extends({}, rest, {
        type: "button",
        id: id,
        className: buttonClassName,
        style: style,
        onClick: this.handleOnOptionClick,
        disabled: disabled,
        ref: this.setReferences,
        role: "option",
        "aria-selected": isSelected
      }), this.renderChildren()), divider && dividerPosition === BOTTOM && /*#__PURE__*/_react.default.createElement(_index.SbSelectDivider, {
        className: dividerClass,
        style: dividerStyle
      }));
    }
  }]);

  return SbSelectOption;
}(_react.Component);

exports.SbSelectOption = SbSelectOption;

_defineProperty(SbSelectOption, "propTypes", {
  value: _shapes.stringOrNumber.isRequired,
  mode: _shapes.modeShape,
  onClick: _propTypes.default.func,
  onOptionClick: _propTypes.default.func,
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  divider: _propTypes.default.oneOfType([_propTypes.default.bool, _shapes.dividerShape]),
  disabled: _propTypes.default.bool,
  iconClass: _propTypes.default.string,
  isPreselected: _propTypes.default.bool,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  indeterminate: _propTypes.default.bool,
  setSelected: _propTypes.default.func,
  isSelected: _propTypes.default.bool,
  children: _propTypes.default.node
});

_defineProperty(SbSelectOption, "defaultProps", {
  onClick: _constants.NOOP,
  mode: RADIO,
  className: null,
  label: null,
  id: null,
  style: null,
  divider: null,
  disabled: false,
  iconClass: null,
  isPreselected: false,
  onMouseEnter: _constants.NOOP,
  onMouseLeave: _constants.NOOP,
  onOptionClick: _constants.NOOP,
  indeterminate: false,
  setSelected: _constants.NOOP,
  isSelected: false,
  children: null
});
//# sourceMappingURL=sb-select-option.js.map